module.exports = __webpack_public_path__ + "72b1417b3c27e0d66b1eb01970d641f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/ybfooter/images/qr-code.jpg
// module id = 639
// module chunks = 3